import { Component } from '@angular/core';

@Component({
  selector: 'app-tags',
  template: require('./tags.component.html'),
  styles: ['./tags.component.less'],
})

/** @desc Container component to handle tags **/
export class TagsComponent {}



// WEBPACK FOOTER //
// ./src/app/tags/tags.component.ts